import { render, staticRenderFns } from "./BlockProgressionSelect.vue?vue&type=template&id=61ec2971&scoped=true&"
import script from "./BlockProgressionSelect.vue?vue&type=script&lang=ts&"
export * from "./BlockProgressionSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BlockProgressionSelect.vue?vue&type=style&index=0&id=61ec2971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec2971",
  null
  
)

export default component.exports